import type { IconProps } from '@launchpad-ui/icons';
import { Icon } from '@launchpad-ui/icons';

/**
 * ClickHouse mark (from `static/img/integrations/clickhouse/assets/images/square.svg`).
 * Inline SVG so we do not need an `app-icon-clickhouse` sprite entry.
 */
export function ClickHouseIcon(props: IconProps) {
  return (
    <Icon {...props} viewBox="0 0 64 64">
      <rect width="64" height="64" rx="8" fill="#FACC15" />
      <rect x="5" y="5" width="5.9998" height="53.9982" rx="1.45943" fill="#161517" />
      <rect x="17" y="5" width="5.9998" height="53.9982" rx="1.45943" fill="#161517" />
      <rect x="29.001" y="5" width="5.9998" height="53.9982" rx="1.45943" fill="#161517" />
      <rect x="40.998" y="5" width="5.9998" height="53.9982" rx="1.45943" fill="#161517" />
      <rect x="53.001" y="26.0005" width="5.9998" height="11.9996" rx="1.45943" fill="#161517" />
    </Icon>
  );
}
